// Generated by scripts/update-seeq-icons.js from src/svg/seeq/analysis.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcAnalysis = {
  prefix: 'fak',
  iconName: 'analysis' as IconName,
  icon: [
    1328,
    1024,
    [],
    'f956',
    'M216.5 1024h-153.2c-35 0-63.4-28.4-63.3-63.4s28.4-63.4 63.3-63.3h104.1l119.1-470.9c6.6-28.4 32.1-47.3 61.5-47.2h125.7l70-330c5.7-29.3 32.1-50.1 61.4-50.1h146.6c30.3 0 56.7 21.7 62.4 52l118.2 686.4 127.6-386.7c8.5-25.5 32.1-43.5 59.6-43.5h147.5c35 0 63.4 28.4 63.3 63.3s-28.4 63.4-63.3 63.4h-102.1l-130.5 394.3c-8.5 25.5-32.1 43.5-59.6 43.5h-94.5c-30.3 0-56.7-21.7-62.4-52l-120.1-695h-42.6l-69.9 330c-5.7 29.3-32.1 50.1-61.5 50.1h-127.6l-119.2 470.9c-6.6 28.4-32.1 47.3-61.4 47.3h0.9z',
  ],
} satisfies IconDefinition;
